import React, { useState, useContext } from 'react';
import { AppBar, Toolbar, IconButton, Typography, Button, Menu, MenuItem } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const Navbar = () => {
    const { auth, logout } = useContext(AuthContext);
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const navigate = useNavigate();

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMenuOpen = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    const handleUserList = () => {
        navigate('/users');
        handleMenuClose();
    };

    const handleProfile = () => {
        navigate('/profile');
        handleClose();
    };

    const handleLogout = () => {
        logout();
        handleClose();
    };

    const authLinks = (
        <div>
            <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
            >
                {auth.user ? auth.user.icon : <PersonIcon sx={{ fontSize: 32 }} />}
            </IconButton>
            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={handleProfile}>Профиль</MenuItem>
                <MenuItem onClick={handleLogout}>Выйти</MenuItem>
            </Menu>
        </div>
    );

    const guestLinks = (
        <>
            <Button color="inherit" component={Link} to="/login">Вход</Button>
            <Button color="inherit" component={Link} to="/register">Регистрация</Button>
        </>
    );

    return (
        <AppBar position="static">
            <Toolbar>
                {auth.isAuthenticated && (
                    <div>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            onClick={handleMenuOpen}
                            sx={{ mr: 2 }}
                        >
                            <MenuIcon sx={{ fontSize: 32 }} />
                        </IconButton>
                        <Menu
                            id="menu-appbar-main"
                            anchorEl={menuAnchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(menuAnchorEl)}
                            onClose={handleMenuClose}
                        >
                            {auth.user && auth.user.role === 'root' && (
                                <MenuItem onClick={handleUserList}>Список пользователей</MenuItem>
                            )}
                            {auth.user && auth.user.role === 'root' && (
                                <MenuItem onClick={() => { navigate('/questions'); handleMenuClose(); }}>Вопросы</MenuItem>
                            )}
                            {auth.user && auth.user.role === 'root' && (
                                <MenuItem onClick={() => { navigate('/bible'); handleMenuClose(); }}>Библия</MenuItem>
                            )}
                        </Menu>
                    </div>
                )}
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    Библейская викторина
                </Typography>
                {auth.isAuthenticated ? authLinks : guestLinks}
            </Toolbar>
        </AppBar>
    );
};

export default Navbar;